var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlueButton } from '@hn-ui/buttons';
import { Modal } from '@hn-ui/modals';
import { ModalContainer, ModalTitle, ModalInfo, ModalHeader } from './Common';
var DeleteModal = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 's' : _b, title = _a.title, info = _a.info, isOpen = _a.isOpen, onClose = _a.onClose, onDelete = _a.onDelete;
    return (_jsx(Modal, __assign({ showCloseButton: true, open: isOpen, onClose: onClose, size: size, showOverlay: true }, { children: _jsxs(ModalContainer, { children: [_jsxs(ModalHeader, { children: [_jsx(ModalTitle, { children: title }, void 0), _jsx(ModalInfo, { children: info }, void 0)] }, void 0), _jsx(BlueButton, __assign({ fit: true, onClick: onDelete }, { children: "Delete" }), void 0)] }, void 0) }), void 0));
};
export { DeleteModal };
